import Moment from "moment";

export default class LocalStorageUtils {
  static getLocalStorageBool(key: string): boolean {
    try {
      const item: string = window.localStorage.getItem(key);
      let checkboxFlag = null;
      if (item == "true") checkboxFlag = true;
      if (item == "false") checkboxFlag = false;
      return checkboxFlag ? checkboxFlag : null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  static getLocalStorageDate(key: string): Moment.Moment {
    try {
      const item: string = window.localStorage.getItem(key);

      if (item) {
        return Moment(item);
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  static getLocalStorage(key: string): any {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  static setLocalStorageItem(key: string, value: any) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.log(error);
    }
  }

  static removeLocalStorageItem(key: string) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  }
}
